import { Button, Form, Input, Modal, notification } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLoginStorage, getSecretKey, getSIGN } from "../LocalStorage/Locals";

const RefreshPhonePage = () => {
  const [phone, setPhone] = useState<string>("");
  const [isValid, setIsValid] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const onFinish = async (values: { phone: string }) => {
    await fetchItemData();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPhone(value);
  };

  const fetchItemData = async () => {
    const response = await fetch(
      "https://plg.kras.ru/PlgApi.ashx?CMD=CHANGE_NUMBER&login=" +
        getLoginStorage() +
        "&KEY=" +
        getSecretKey() +
        "&SIGN=" +
        getSIGN() +
        "&new_phone=" +
        phone
    );
    const data = await response.json();

    if (data.ok === true) {
      setModalOpen(true);
    } else {
      // Показываем уведомление об ошибке
      notification.error({
        message: "Ошибка",
        description: data.error,
      });
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    // Проверяем, соответствует ли номер телефона формату
    const phonePattern = /^\+7[0-9]{10}$/;
    setIsValid(phonePattern.test(phone));
  }, [phone]);

  return (
    <div className="container4">
      <Form name="phone_number_form" onFinish={onFinish} layout="vertical">
        <Form.Item
          name="phone"
          label="Номер телефона"
          rules={[
            {
              required: true,
              message: "Пожалуйста, введите номер телефона!",
            },
            {
              pattern: /^\+7[0-9]{10}$/,
              message: "Номер телефона должен быть в формате +7XXXXXXXXXX",
            },
          ]}
        >
          <Input
            value={phone}
            onChange={handleChange}
            placeholder="Введите номер телефона"
          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={!isValid}>
            Отправить
          </Button>
        </Form.Item>
      </Form>

      {/* Модальное окно для успешного изменения номера */}
      <Modal
        closable={false}
        title="Успех"
        open={modalOpen} // Используем open вместо visible
        footer={[<Button onClick={() => navigate("/login")}>Ок</Button>]}
      >
        <p>
          Ваш новый номер телефона для входа - <strong> {phone}</strong>{" "}
        </p>
      </Modal>
    </div>
  );
};

export default RefreshPhonePage;
